import { createAction, props } from '@ngrx/store';
import { ToggleResponse } from './feature-toggle.models';

export const loadFeatureToggleSuccess = createAction(
  '[Common Feature Toggle] Load Success',
  props<{ toggleProfile: ToggleResponse }>()
);

export const loadFeatureToggleFail = createAction('[Common Feature Toggle] Load Fail', props<{ error: unknown }>());
